// Aperçu du mini-site : le HTML rendu par le serveur référence ses images par
// leur nom nu (`bd_chapitre1.jpg`, `hero.jpg`…), comme sur le site publié. Dans
// une iframe `srcdoc`, ces noms ne résolvent vers rien : on les remplace par
// des URLs de blobs chargés avec le jeton, sans toucher au gabarit serveur.

export const NOMS_BD = [1, 2, 3, 4, 5].map((i) => `bd_chapitre${i}.jpg`).concat("bd_complete.jpg");

export function libelleBd(name) {
  if (name === "bd_complete.jpg") return "planche complète";
  return `BD du chapitre ${name.replace(/\D/g, "")}`;
}

// Photos que le brouillon référence (héro + interludes), sans doublon ni vide.
export function nomsPhotos(draft) {
  const noms = [draft?.hero?.photo_filename]
    .concat((draft?.interludes || []).map((i) => i?.photo_filename))
    .filter(Boolean);
  return Array.from(new Set(noms));
}

function echapperXml(s) {
  return String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

// Image grise portant un libellé, à la place d'une planche absente de l'aperçu.
// Encodée en base64, jamais en pourcentage : `encodeURIComponent` garde
// l'apostrophe, et « l'aperçu » fermait alors le `url('…')` des cases mobiles
// du gabarit (quatre cases vides, ni grises ni libellées — trouvé au gate).
export function placeholderManquant(libelle, sousTitre = "absente de l'aperçu") {
  const svg =
    `<svg xmlns="http://www.w3.org/2000/svg" width="1200" height="1600" viewBox="0 0 1200 1600">` +
    `<rect width="1200" height="1600" fill="#e5e7eb"/>` +
    `<text x="600" y="780" text-anchor="middle" font-family="sans-serif" font-size="56" fill="#6b7280">${echapperXml(libelle)}</text>` +
    `<text x="600" y="860" text-anchor="middle" font-family="sans-serif" font-size="40" fill="#9ca3af">${echapperXml(sousTitre)}</text>` +
    `</svg>`;
  return `data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(svg)))}`;
}

// Une URL de data doit pouvoir s'insérer telle quelle entre des guillemets
// simples, doubles ou dans un `url(...)` : aucun de ces caractères. Le base64
// n'en produit aucun, mais une image servie sans encodage en produirait.
export function urlInserableEnCss(url) {
  return !/["'()\s]/.test(url);
}

function echapperRegex(s) {
  return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

// Remplace chaque nom nu par son URL, seulement en position d'attribut ou
// d'`url(...)` : jamais au milieu d'un autre nom ni dans le texte courant.
// Les noms les plus longs passent d'abord (`photo_1.jpg` ⊄ `photo_12.jpg`
// grâce aux bornes, mais autant ne pas dépendre de l'ordre).
export function substituerAssets(html, urls) {
  const noms = Object.keys(urls).sort((a, b) => b.length - a.length);
  return noms.reduce((acc, nom) => {
    const re = new RegExp(`(["'(])${echapperRegex(nom)}(["')])`, "g");
    return acc.replace(re, (_, avant, apres) => `${avant}${urls[nom]}${apres}`);
  }, html);
}

// Noms de planches encore nus après substitution : doit être vide, sinon
// l'iframe montrerait des images cassées sans que personne ne le voie.
export function residusBd(html) {
  const re = /["'(]((?:bd_chapitre\d|bd_complete)\.jpg)["')]/g;
  const trouves = new Set();
  let m;
  while ((m = re.exec(html)) !== null) trouves.add(m[1]);
  return Array.from(trouves);
}
